<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.userId}}</span>
                        <span>({{scope.row.nickName}})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" align="center" width="120px"></el-table-column>

                <el-table-column prop="toUserId" label="交换用户" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.toUserId}}</span>
                        <span>({{scope.row.toNickName}})</span>
                    </template>
                </el-table-column>
                <el-table-column prop="toSate" label="交换用户状态" align="center" width="120px"></el-table-column>
                <el-table-column prop="toPhone" label="交换手机号" align="center" width="120px"></el-table-column>
                <el-table-column prop="wechat" label="交换微信号" align="center" width="120px"></el-table-column>
                <el-table-column prop="chuLi" label="状态" align="center" width="100px">
                    <template slot-scope="scope">
                        {{scope.row.chuLi?'已处理':'未处理'}}
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="交换时间" align="center" width="160px"></el-table-column>
                <el-table-column prop="" label="操作" align="center" width="160px">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="updateTip(scope.row)" v-if="!scope.row.isChuli">点击处理</el-button>
                        <span v-else>已处理</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="处理" width="640px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        处理情况
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.chuLiType" placeholder="请选择">
                            <el-option
                            v-for="item in resultList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="item">
                    <div class="label">
                        是否给予奖励
                    </div>
                    <div class="value">
                        <el-select v-model="updateData.jiangLi" placeholder="请选择">
                            <el-option
                            v-for="item in isGiveList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="update()">确认</el-button>
                </div>

            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                Phone:'',
                toPhone:'',
                current:1,
                size:10,
            },
            queryList:[
                // {type: "input",label: "查询:",name: "Keyword"},
                {type: "input",label: "手机:",name: "Phone"},
                {type: "input",label: "交换手机号:",name: "toPhone"}
            ],

            formData:{
                nickName:'',
                phone:'',
                toNickName:'',
                toPhone:'',
            },
            formList:[
                {type: "input",label: "委托主体名称:",name: "Name",},
                {type: "select",label: "委托主体类型:",name: "Type",options:wtlxList},
                {type: "input",label: "承保机构:",name: "UnderwritingAgency",},
                {type: "select",label: "是否新来源:",name: "IsNew",options:isNewList},
            ],
            // 提交规则
            formRules:{
                Name: [{ required: true, message: '请填写委托主体名称', trigger: 'blur' }],
                Type: [{ required: true, message: '请填写委托主体类型', trigger: 'change' }],
                UnderwritingAgency: [{ required: true, message: '请填写承保机构', trigger: 'blur' }],
                IsNew: [{ required: true, message: '请填写是否新来源', trigger: 'change' }],
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            updateData:{
                userId:null,
                toUserId:null,
                jiangLi: false,
                chuLiType: 3
            },
            isGiveList:[
                {label:'是',value:true},
                {label:'否',value:false},
            ],
            resultList:[
                // {
                //     label:'将举报用户微信号换手机号,并解冻',
                //     value:1,
                // },
                {
                    label:'拉黑',
                    value:4,
                },
                // {
                //     label:'删除用户',
                //     value:2,
                // },
                {
                    label:'冻结用户',
                    value:3,
                }
            ]
        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        // 删除提示
        updateTip(row){
            console.log('row');
            console.log(row);
            this.updateData = {
                userId:row.userId,
                toUserId:row.toUserId,
                jiangLi: false,
                isChuli: true
            }
            this.isUpdateDialog = true;
           
        },
        async update(){
            console.log(this.updateData);
            let res = await api.chuliJieSuo(this.updateData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已处理完成'
                });
                this.isUpdateDialog = false;
                
                this.loadingData();
            }
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            
            let res  = await api.AdminStandQueryUserToUserChat(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        // 查询
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                Phone:'',
                toPhone:'',
                current:1,
                size:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        
       
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
            .value{
                width: 250px;
            }
        }
        .picList{
            display: flex;
            flex-wrap: wrap;
            .pic{
                position: relative;
                margin: 5px;
                width: 100px;
                height: 100px;
                .pic-edit{
                    position: absolute;
                    z-index: 10;
                    top: 0;
                    right: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0 , 0.6);
                    cursor: pointer;
                    i{
                        color: #ffffff;
                    }
                    .error{
                        color: #f56c6c;
                    }
                    .success{
                        color: #a9ffa9;
                    }
                }
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
